export const triggerEvent = (el, name) => {
    const event = new Event(name);
    el.dispatchEvent(event);
};